import { render, staticRenderFns } from "./SugestaoDeCompra.vue?vue&type=template&id=6667deec&scoped=true"
import script from "./SugestaoDeCompra.vue?vue&type=script&lang=js"
export * from "./SugestaoDeCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6667deec",
  null
  
)

export default component.exports